import "./turn-notification.css";

export function TurnNotification({
  active,
  subject,
  detail,
}: {
  active: boolean;
  subject: string;
  detail: string;
}) {
  return (
    <div className="turn-notification-region" role="status" aria-live="polite" aria-atomic="true">
      <div
        className={`turn-notification${active ? " is-active" : ""}`}
        title={`${subject}${detail}`}
      >
        <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
          <path d="m13 39 20-27" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
          <path d="M9 16Q28-2 41 25L28 15Q18 10 9 16Z" fill="currentColor" />
          <path
            d="m8 29-4 1m35 5 4 3M22 5l-1-3"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
        <strong>
          <span>{subject}</span>
          <span>{detail}</span>
        </strong>
      </div>
    </div>
  );
}
